export default "__VITE_ASSET__C2Zcgn56__"